export const REMOVETEXT = "Remove";
export const CHANGES_SAVED_MSG = "Changes are saved successfully.";
export const REGEX_ALPHANUMERIC =
  /^(?![ _-])(?!.*[ _-]$)(?!.*--)(?!.*__)(?!.*\s{2})[A-Za-z0-9 _-]+$/;
const SUB_DOMAIN_LABEL = /[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?/;
export const SUB_DOMAIN_REGEX = new RegExp(
  `^${SUB_DOMAIN_LABEL.source}(?:\\.${SUB_DOMAIN_LABEL.source})*$`,
);
